<template>
<div>
  <div v-if="!emprestimosEmBreve" class="d-flex justify-content-center align-items-top dashboard">
    <div class="MyLoans">
        <div class="MyLoansHeader">
            <div class="row tit_page">
                <div class="col-12 col-lg-6 text-left align-middle">
                    <h1>Meus empréstimos</h1>
                </div>
                <div class="col-12 col-lg-6 text-right align-middle d-flex justify-content-end">
                    <div class="RequestLoan">
                        <a href="https://emprestimos.iouu.com.br/pedido" title="Solicitar novo empréstimo" class="t-head">
                            <i class="icon-bg-plus"></i> Solicitar novo empréstimo
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <hr class="divider">
        <div class="MyLoansContent">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">

                        <!-- LISTA OPORTUNIDADES COMO CARDS MOBILE -->
                        <div class="d-block d-sm-none">
                            <div class="cards">
                                <dl v-for="item in this.emprestimos" v-bind:key="item.IdOportunidade" :class=" 'rating-' + lowerCase(item.Score) " >
                                    <dt class="rating">Score <span class="circle score">{{formatarScore(item.Score)}}</span></dt>
                                    <dt>ID: <router-link to="">{{ajustIdOportunidade(item.IdOportunidade,5)}}</router-link></dt>
                                    <dt>Solicitante</dt>
                                    <dd>{{Nome(item)}}<router-link v-if="item.BoletosAtrasados != undefined && item.BoletosAtrasados != 0" class="badge badge-pill badge-danger" style="text-decoration:none!important;" :to="Detalhes(item.CodProduto, item._id)" title="Atualizar">{{item.BoletosAtrasados}}</router-link></dd>
                                    <dt>CNPJ/CPF</dt>
                                    <dd>{{formatted(item.Documento)}}</dd>
                                    <dt>Tipo do empréstimo</dt>
                                    <dd>{{formatarTipoEmprestimo(item.TipoEmprestimo)}}</dd>
                                    <dt>Valor solicitado</dt>
                                    <dd>R$ {{money(item.Valor)}}</dd> 
                                    <dt>Taxa de juros</dt>
                                    <dd>{{item.TaxaJuros==0 || item.TaxaJuros == undefined ?"-":item.TaxaJuros+ "% a.m"}}</dd>
                                    <dt>Prazo</dt>
                                    <!-- <dd>{{item.Alongamento ? item.PrazoFinal : item.Prazo}} Meses</dd> -->
                                    <dd>{{item.PrazoFinal}} Meses</dd>

                                    <dd class="align-middle text-center">
                                      
                                            <div class="ss" v-if=" AjustaStatus(item)  == 'Incompleto'">
                                               <span class="ss-analise">{{AjustaStatus(item)}}</span>
                                            </div>
                                            <div class="ss" v-if="AjustaStatus(item) == 'Processando'">
                                                <span class="ss-analise">{{item.StatusDocumentos == "PENDENTE" ?"Documento Pendente":"Processando"}}</span>
                                            </div>
                                            <div class="ss" v-if="AjustaStatus(item) == 'Publicado'">
                                                <span class="ss-captando">{{AjustaStatus(item) == 'Publicado' ?"Captando":AjustaStatus(item)}}</span>
                                            </div>


                                            <div class="ss" v-if=" AjustaStatus(item) == 'Encerrado' && (!item.GerouBoletosPagamento || item.GerouBoletosPagamento == undefined) && (item.CCBsAssinaturas == false || item.CCBsAssinaturas == undefined)">
                                                <span class="ss-aprovado">Aguardando Formalização</span>
                                            </div>


                                            <div class="ss" v-if=" AjustaStatus(item) == 'Encerrado' && (!item.GerouBoletosPagamento || item.GerouBoletosPagamento == undefined)  && (item.CCBsAssinaturas == true)">
                                                <span class="ss-encerrado">Processando Desembolso</span>
                                            </div>



                                            <div class="ss" v-if=" AjustaStatus(item)  == 'Aprovado'">
                                               <span class="ss-aprovado">{{AjustaStatus(item) == 'Aprovado' && (!item.AprovadoCliente && item.AprovadoCliente != undefined) ?"Proposta Gerada":"Aguardando Publicação"}}</span>
                                            </div>
                                            <div class="ss" v-if=" AjustaStatus(item)  == 'Negado' ">
                                               <span class="ss-negado">{{AjustaStatus(item) == 'Negado' && !item.NegadoCliente ?"Negado":"Negado"}}</span>
                                            </div>
                                             <div class="ss" v-if=" AjustaStatus(item)  == 'Encerrado' && item.GerouBoletosPagamento && (item.BoletosAtrasados == undefined || item.BoletosAtrasados == 0)">
                                               <span class="ss-emprestimoativo">Empréstimo Ativo</span>
                                            </div>
                                            <div class="ss" v-if=" AjustaStatus(item)  == 'Encerrado' && item.GerouBoletosPagamento && (item.BoletosAtrasados != undefined && item.BoletosAtrasados != 0)">
                                               <span class="ss-negado">Boleto em atraso</span>
                                        </div>
                                    </dd>

                                    <dd class="align-middle" v-if="( item.TipoEmprestimo == 'emprestimo-coletivo' || item.TipoEmprestimo == 'emprestimo-de-impacto2' || item.TipoEmprestimo == 'emprestimo-social' ) && ( AjustaStatus(item) =='Processando' || AjustaStatus(item)  == 'Negado' || (item.AprovadoCliente != undefined && !item.AprovadoCliente && AjustaStatus(item) != 'Publicado' && AjustaStatus(item) != 'Encerrado'  && AjustaStatus(item) != 'Incompleto' ))">    
                                        <router-link v-if="item.StatusAnalise != 'APROVADO' && item.StatusDocumentos != 'PENDENTE'" :to="documentos('EMPCOL', item._id)" class="btn btn-link mob" title="Atualizar">Ver mais detalhes</router-link>
                                        <router-link v-if="item.StatusAnalise == 'APROVADO' && item.StatusDocumentos != 'PENDENTE'" :to="documentos('EMPCOL', item._id)" class="btn btn-link mob" title="Atualizar">Visualizar Proposta</router-link>
                                        <router-link v-else-if="item.StatusDocumentos == 'PENDENTE'" :to="DocumentosFaltantes('EMPCOL', item._id)" class="btn btn-link mob" title="Atualizar">Documentos</router-link>
                                    </dd>

                                    <dd class="align-middle" v-else-if="(item.TipoEmprestimo == 'emprestimo-coletivo' || item.TipoEmprestimo == 'emprestimo-de-impacto2'|| item.TipoEmprestimo == 'emprestimo-social') && (item.StatusAnalise =='APROVADO' || item.StatusAnalise =='PUBLICADO'|| item.StatusAnalise =='ENCERRADO') && (item.AprovadoCliente || item.AprovadoCliente == undefined)">
                                        <router-link v-if="(!item.GerouBoletosPagamento || item.GerouBoletosPagamento == undefined) && (item.CCBsAssinaturas == false || item.CCBsAssinaturas == undefined) && item.StatusAnalise =='ENCERRADO'  " :to="AssinaturaCCB(item._id)" class="btn btn-link mob" title="Assinar">Assinar CCBs</router-link>
                                        <router-link v-if="(!item.GerouBoletosPagamento || item.GerouBoletosPagamento == undefined) &&item.StatusAnalise !='ENCERRADO'" :to="Detalhes('EMPCOL', item._id)" class="btn btn-link mob" title="Atualizar">Ver mais detalhes</router-link>
                                        <router-link v-if="(!item.GerouBoletosPagamento || item.GerouBoletosPagamento == undefined) && item.CCBsAssinaturas == true " :to="Detalhes('EMPCOL', item._id)" class="btn btn-link mob" title="Atualizar">Ver mais detalhes</router-link>
                                        <router-link v-if="item.GerouBoletosPagamento && (item.BoletosAtrasados == undefined || item.BoletosAtrasados == 0)" :to="Detalhes('EMPCOL', item._id)" class="btn btn-link mob" title="Atualizar">Boletos</router-link> 
                                        <router-link v-if="item.GerouBoletosPagamento && (item.BoletosAtrasados != undefined && item.BoletosAtrasados != 0)" :to="Detalhes('EMPCOL', item._id)" class="btn btn-link mob" title="Atualizar">Ver mais detalhes</router-link>
                                        <router-link :to="Detalhes('EMPCOL', item._id)" class="btn btn-link mob" title="Atualizar"><i class="icon icon-eye-2 md">&nbsp;</i></router-link>
                                    </dd>

                                    <dd class="align-middle" v-if=" item.TipoEmprestimo == 'emprestimo-pessoal' && ( AjustaStatus(item) =='Processando' || AjustaStatus(item)  == 'Negado' || (item.AprovadoCliente != undefined && !item.AprovadoCliente && AjustaStatus(item) != 'Publicado'))">
                                        <router-link v-if="item.StatusAnalise != 'APROVADO' && item.StatusDocumentos != 'PENDENTE'" :to="documentos('EMPPES', item._id)" class="btn btn-link mob" title="Atualizar">Ver mais detalhes</router-link>
                                        <router-link v-if="item.StatusAnalise == 'APROVADO' && item.StatusDocumentos != 'PENDENTE'" :to="documentos('EMPPES', item._id)" class="btn btn-link mob" title="Atualizar">Visualizar Proposta</router-link>
                                        <router-link v-else-if="item.StatusDocumentos == 'PENDENTE'" :to="DocumentosFaltantes('EMPPES', item._id)" class="btn btn-link mob" title="Atualizar">Documentos</router-link>
                                    </dd>

                                    <dd class="align-middle" v-if="(item.TipoEmprestimo == 'emprestimo-de-impacto' || item.TipoEmprestimo == 'emprestimo-social') && (item.StatusAnalise =='APROVADO' || item.StatusAnalise =='PUBLICADO' || item.StatusAnalise =='ENCERRADO') && item.AprovadoCliente">
                                        <router-link :to="Detalhes('EMPIMP', item._id)" class="btn btn-link mob" title="Atualizar">Ver mais detalhes</router-link>
                                    </dd> 

                                    <dd class="align-middle" v-if="item.TipoEmprestimo == 'emprestimo-ccb' && (item.StatusAnalise =='APROVADO' || item.StatusAnalise =='PUBLICADO' || item.StatusAnalise =='ENCERRADO')">
                                        <router-link :to="Detalhes('EMPCCB', item._id)" class="btn btn-link mob" title="Atualizar">Ver mais detalhes</router-link>
                                    </dd>

                                    <dd class="align-middle" >
                                        <router-link v-if="AjustaStatus(item) =='Incompleto'"  :to="AjustaLink(item)" class="btn btn-link mob" title="Atualizar">Atualizar</router-link>
                                    </dd>

                                </dl>
                            </div>
                        </div>
                        <!-- FINAL LISTA OPORTUNIDADES COMO CARDS MOBILE -->

                        <div class="table-responsive d-none d-sm-block">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th scope="col" width="70" class="align-middle text-center">
                                            ID
                                        </th>
                                        <th scope="col"  width="150" class="align-middle">
                                            Empréstimo
                                        </th> 
                                        <th scope="col" class="align-middle">
                                            Solicitante
                                        </th>
                                        <th scope="col" width="150" class="align-middle text-center">
                                            CNPJ/CPF
                                        </th>
                                        <th scope="col"  class="align-middle text-center">
                                            Score
                                        </th>
                                        <th scope="col"  class="align-middle text-center">
                                            Taxa de Juros
                                        </th>
                                        <th scope="col" width="90" class="align-middle">
                                            Prazo
                                        </th>
                                        <th scope="col" class="align-middle text-center">
                                            Valor solicitado
                                        </th>
                                        <!-- <th scope="col" class="align-middle text-center">
                                           Data
                                        </th> -->
                                        <th scope="col" width="150" class="align-middle text-center">
                                            Status
                                        </th>
                                        <th scope="col" width="10"></th>
                                    </tr>
                                </thead>
                                <tbody>

                                    
                                    <tr v-for="item in this.emprestimos" v-bind:key="item.IdOportunidade" :class=" 'rating-' + lowerCase(item.Score) " >
                                        <td class="align-middle text-center">
                                            {{ajustIdOportunidade(item.IdOportunidade,5)}}
                                        </td> 
                                        <td class="align-middle">
                                           {{formatarTipoEmprestimo(item.TipoEmprestimo)}}
                                        </td> 
                                        <td class="align-middle">
                                           {{Nome(item)}}<router-link v-if="item.BoletosAtrasados != undefined && item.BoletosAtrasados != 0" class="badge badge-pill badge-danger" style="text-decoration:none!important;" :to="Detalhes(item.CodProduto, item._id)"  title="Atualizar">{{item.BoletosAtrasados}}</router-link>
                                        </td>
                                        <td class="align-middle text-center">
                                            {{formatted(item.Documento)}}
                                        </td>
                                        <td class="rating align-middle text-center" scope="col">
                                            <span class="rounded-circle"></span>
                                            <span>{{formatarScore(item.Score)}}</span>
                                        </td>
                                        <td class="align-middle text-center">
                                            {{item.TaxaJuros==0 || item.TaxaJuros == undefined ?"-":item.TaxaJuros+ "% a.m"}}
                                        </td>
                                        <td class="align-middle">
                                            {{item.Alongamento ? item.PrazoFinal : item.Prazo}} Meses
                                        </td>
                                        <td class="align-middle text-center">
                                            R$ {{(item.ValorSolicitado == 0 || item.ValorSolicitado == undefined) ? money(item.Valor) : money(item.ValorSolicitado)}}
                                        </td>

                                        <!-- <td class="align-middle text-center">
                                            {{AjustaData(item.Created)}}
                                        </td> -->
                                        <td class="align-middle text-center">

                                            <div class="ss" v-if=" AjustaStatus(item)  == 'Incompleto'">
                                               <span class="ss-analise">{{AjustaStatus(item)}}</span>
                                            </div>
                                            <div class="ss" v-if="AjustaStatus(item) == 'Processando'">
                                                <span class="ss-analise">{{item.StatusDocumentos == "PENDENTE" ?"Documento Pendente":"Processando"}}</span>
                                            </div>
                                            <div class="ss" v-if="AjustaStatus(item) == 'Publicado'">
                                                <span class="ss-captando">{{AjustaStatus(item) == 'Publicado' ?"Captando":AjustaStatus(item)}}</span>
                                            </div>

                                            <div class="ss" v-if=" AjustaStatus(item) == 'Encerrado' && (!item.GerouBoletosPagamento || item.GerouBoletosPagamento == undefined) && (item.CCBsAssinaturas == false || item.CCBsAssinaturas == undefined)">
                                                <span class="ss-aprovado">Aguardando Formalização</span>
                                            </div>


                                            <div class="ss" v-if=" AjustaStatus(item) == 'Encerrado' && (!item.GerouBoletosPagamento || item.GerouBoletosPagamento == undefined) && (item.CCBsAssinaturas == true)">
                                                <span class="ss-encerrado">Processando Desembolso</span>
                                            </div>
                                            <div class="ss" v-if=" AjustaStatus(item)  == 'Aprovado'">
                                               <span class="ss-aprovado">{{AjustaStatus(item) == 'Aprovado' && (!item.AprovadoCliente && item.AprovadoCliente != undefined) ?"Proposta Gerada":"Aguardando Publicação"}}</span>
                                            </div>
                                            <div class="ss" v-if=" AjustaStatus(item)  == 'Negado' ">
                                               <span class="ss-negado">{{AjustaStatus(item) == 'Negado' && !item.NegadoCliente ?"Negado":"Negado"}}</span>
                                            </div>
                                             <div class="ss" v-if=" (item.BoletosAtrasados == undefined || item.BoletosAtrasados == 0) && AjustaStatus(item)  == 'Encerrado' && item.GerouBoletosPagamento">
                                               <span class="ss-emprestimoativo">Empréstimo Ativo</span>
                                            </div>
                                             <div class="ss" v-if=" AjustaStatus(item)  == 'Encerrado' && item.GerouBoletosPagamento && (item.BoletosAtrasados != undefined && item.BoletosAtrasados != 0)">
                                               <span class="ss-negado">Boleto em atraso</span>
                                            </div>
                                        </td>

                                        <td class="align-middle" v-if="( item.TipoEmprestimo == 'emprestimo-coletivo' || item.TipoEmprestimo == 'emprestimo-de-impacto2' || item.TipoEmprestimo == 'emprestimo-social' ) && ( AjustaStatus(item) =='Processando' || AjustaStatus(item)  == 'Negado' || (item.AprovadoCliente != undefined && !item.AprovadoCliente && AjustaStatus(item) != 'Publicado' && AjustaStatus(item) != 'Encerrado'  && AjustaStatus(item) != 'Incompleto' ))">
                                            
                                            <router-link v-if="item.StatusAnalise != 'APROVADO' && item.StatusDocumentos != 'PENDENTE'" :to="documentos('EMPCOL', item._id)" class="btn btn-link desk" title="Atualizar">Ver mais detalhes</router-link>
                                            <router-link v-if="item.StatusAnalise == 'APROVADO' && item.StatusDocumentos != 'PENDENTE'" :to="documentos('EMPCOL', item._id)" class="btn btn-link desk" title="Atualizar">Visualizar Proposta</router-link>
                                            <router-link v-else-if="item.StatusDocumentos == 'PENDENTE'" :to="DocumentosFaltantes('EMPCOL', item._id)" class="btn btn-link desk" title="Atualizar">Documentos</router-link>

                                            <router-link v-if="item.StatusAnalise != 'APROVADO' && item.StatusDocumentos != 'PENDENTE'" :to="documentos('EMPCOL', item._id)" class="btn btn-link mob" title="Atualizar">
                                                <i class="icon icon-eye-2 md">&nbsp;</i>
                                            </router-link>  
                                            <router-link v-if="item.StatusAnalise == 'APROVADO' && item.StatusDocumentos != 'PENDENTE'" :to="documentos('EMPCOL', item._id)" class="btn btn-link mob" title="Atualizar">
                                                <i class="icon icon-eye-2 md">&nbsp;</i>
                                            </router-link>  
                                            <router-link v-else-if="item.StatusDocumentos == 'PENDENTE'" :to="DocumentosFaltantes('EMPCOL', item._id)" class="btn btn-link mob" title="Atualizar">
                                                <i class="icon icon-eye-2 md">&nbsp;</i>
                                            </router-link>  
                                        </td>

                                         <!-- DETALHES - EMPRESTIMO COLETIVO -->
                                        
                                        <td class="align-middle" v-else-if="(item.TipoEmprestimo == 'emprestimo-coletivo' || item.TipoEmprestimo == 'emprestimo-de-impacto2' || item.TipoEmprestimo == 'emprestimo-social') && (item.StatusAnalise =='APROVADO' || item.StatusAnalise =='PUBLICADO'|| item.StatusAnalise =='ENCERRADO') && (item.AprovadoCliente || item.AprovadoCliente == undefined)">
                                            
                                            <router-link v-if="(!item.GerouBoletosPagamento || item.GerouBoletosPagamento == undefined) && (item.CCBsAssinaturas == false || item.CCBsAssinaturas == undefined) && item.StatusAnalise =='ENCERRADO'  " :to="AssinaturaCCB(item._id)" class="btn btn-link desk" title="Assinar">Assinar CCBs</router-link>
                                            <router-link v-if="(!item.GerouBoletosPagamento || item.GerouBoletosPagamento == undefined) &&item.StatusAnalise !='ENCERRADO'" :to="Detalhes('EMPCOL', item._id)" class="btn btn-link desk" title="Atualizar">Ver mais detalhes</router-link>
                                            <router-link v-if="(!item.GerouBoletosPagamento || item.GerouBoletosPagamento == undefined) && item.CCBsAssinaturas == true " :to="Detalhes('EMPCOL', item._id)" class="btn btn-link desk" title="Atualizar">Ver mais detalhes</router-link>
                                            <router-link v-if="item.GerouBoletosPagamento && (item.BoletosAtrasados == undefined || item.BoletosAtrasados == 0)" :to="Detalhes('EMPCOL', item._id)" class="btn btn-link desk" title="Atualizar">Boletos</router-link> 
                                            <router-link v-if="item.GerouBoletosPagamento && (item.BoletosAtrasados != undefined && item.BoletosAtrasados != 0)" :to="Detalhes('EMPCOL', item._id)" class="btn btn-link desk" title="Atualizar">Ver mais detalhes</router-link>
                                            <router-link :to="Detalhes('EMPCOL', item._id)" class="btn btn-link mob" title="Atualizar"><i class="icon icon-eye-2 md">&nbsp;</i></router-link>
                                        </td>



                                        <td class="align-middle" v-if=" item.TipoEmprestimo == 'emprestimo-pessoal' && ( AjustaStatus(item) =='Processando' || AjustaStatus(item)  == 'Negado' || (item.AprovadoCliente != undefined && !item.AprovadoCliente && AjustaStatus(item) != 'Publicado'))">
                                            <router-link v-if="item.StatusAnalise != 'APROVADO' && item.StatusDocumentos != 'PENDENTE'" :to="documentos('EMPPES', item._id)" class="btn btn-link desk" title="Atualizar">Ver mais detalhes</router-link>
                                            <router-link v-if="item.StatusAnalise == 'APROVADO' && item.StatusDocumentos != 'PENDENTE'" :to="documentos('EMPPES', item._id)" class="btn btn-link desk" title="Atualizar">Visualizar Proposta</router-link>
                                            <router-link v-else-if="item.StatusDocumentos == 'PENDENTE'" :to="DocumentosFaltantes('EMPPES', item._id)" class="btn btn-link desk" title="Atualizar">Documentos</router-link>

                                            <!-- <router-link  :to="documentos('EMPPES', item._id)" class="btn btn-link mob" title="Atualizar">
                                                <i class="icon icon-eye-2 md">
                                                    &nbsp;
                                                </i>
                                            </router-link> -->
                                            <router-link v-if="item.StatusAnalise != 'APROVADO' && item.StatusDocumentos != 'PENDENTE'" :to="documentos('EMPCOL', item._id)" class="btn btn-link mob" title="Atualizar"><i class="icon icon-eye-2 md">&nbsp;</i>
                                            </router-link>  
                                            <router-link v-if="item.StatusAnalise == 'APROVADO' && item.StatusDocumentos != 'PENDENTE'" :to="documentos('EMPCOL', item._id)" class="btn btn-link mob" title="Atualizar">
                                                <i class="icon icon-eye-2 md">&nbsp;</i>
                                            </router-link>  
                                            <router-link v-else-if="item.StatusDocumentos == 'PENDENTE'" :to="DocumentosFaltantes('EMPCOL', item._id)" class="btn btn-link mob" title="Atualizar"><i class="icon icon-eye-2 md">&nbsp;</i></router-link>  
                                        </td>

                                        
                                       
                                        <!-- ::::::::::::::::::::: -->
                                        <!-- DETALHES - EMPRESTIMO PESSOAL 
                                        <td class="align-middle" v-else-if="item.TipoEmprestimo == 'emprestimo-pessoal' && (item.StatusAnalise =='APROVADO' || item.StatusAnalise =='PUBLICADO'|| item.StatusAnalise =='ENCERRADO' )">
                                            <router-link :to="Detalhes('EMPPES', item._id)" class="btn btn-link desk" title="Atualizar">Boletos</router-link> 
                                            <router-link :to="Detalhes('EMPPES', item._id)" class="btn btn-link mob" title="Atualizar"><i class="icon icon-eye-2 md">&nbsp;</i></router-link>
                                        </td>
                                         ::::::::::::::::::::: -->
                                        <!-- DETALHES - EMPRESTIMO DE IMPACTO -->

                                        <td class="align-middle" v-if="(item.TipoEmprestimo == 'emprestimo-de-impacto' || item.TipoEmprestimo == 'emprestimo-social') && (item.StatusAnalise =='APROVADO' || item.StatusAnalise =='PUBLICADO' || item.StatusAnalise =='ENCERRADO') && item.AprovadoCliente">
                                            <router-link :to="Detalhes('EMPIMP', item._id)" class="btn btn-link desk" title="Atualizar">Ver mais detalhes</router-link>

                                            <router-link :to="Detalhes('EMPIMP', item._id)" class="btn btn-link mob" title="Atualizar"><i class="icon icon-eye-2 md">&nbsp;</i></router-link>
                                        </td> 
                                        <!-- :::::::::::::::::::::::: -->
                                        <!-- DETALHES - EMPRESTIMO CCB -->
                                        <td class="align-middle" v-if="item.TipoEmprestimo == 'emprestimo-ccb' && (item.StatusAnalise =='APROVADO' || item.StatusAnalise =='PUBLICADO' || item.StatusAnalise =='ENCERRADO')">
                                            <router-link :to="Detalhes('EMPCCB', item._id)" class="btn btn-link desk" title="Atualizar">Ver mais detalhes</router-link>
                                            <router-link :to="Detalhes('EMPCCB', item._id)" class="btn btn-link mob" title="Atualizar"><i class="icon icon-eye-2 md">&nbsp;</i></router-link>
                                        </td>
                                        <!-- :::::::::::::::::::::: -->
                                        <td class="align-middle" >
                                            <router-link v-if="AjustaStatus(item) =='Incompleto'"  :to="AjustaLink(item)" class="btn btn-link desk" title="Atualizar">Atualizar</router-link>
                                            <router-link v-if="AjustaStatus(item) =='Incompleto'"  :to="AjustaLink(item)" class="btn btn-link mob" title="Atualizar"><i class="icon icon-eye-2 md">&nbsp;</i></router-link>  
                                        </td>

                                         <td class="align-middle"  v-if="AjustaStatus(item) =='Incompleto'  ">
                                         </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>

   <div v-if="emprestimosEmBreve" class="d-flex justify-content-center align-items-center dashboard">
		<div class="dashboard__complete">
			<div class="row">
				<div class="col-12 text-center">
					<h1>Meus empréstimos</h1>
					
					<div>
						<p>Você não tem nenhuma solicitação de empréstimo cadastrada!</p>
                        <!--  Remoção link Solicitar empréstimo (so aparecer quando terminar desenv) -->
                        <!-- <router-link to="/tipo-de-emprestimo" class="btn btn-lg btn-primary">Solicitar empréstimo <img src="/static/assets/images/seta-modal.svg"></router-link> -->
					</div>
				</div>
			</div>
		</div>
  </div>
</div>
</template>

<!-- PAGE CUSTOM STYLE -->
<style lang="scss" scope>
    @import "../assets/styles/iouu/mixins";
    @import "../assets/styles/iouu/variables";

    hr {

        @include xs {
            margin: 10px 0;
        }

        @include ds {
            margin: 15px 0 20px;
        }
    }

    a.badge {
        width: 20px!important;
        height: 20px!important;
        line-height: 16px!important;
        font-size: 10px!important;
        font-weight: bold!important;
        &-danger {
            color: #fff!important;
           
            text-decoration: none!important;
        }

        @include ds {
            width: 17px!important;
            height: 17px!important;
            line-height: 13px!important;
            font-size: 9px!important;
        }
    }

    .btn {
        &:focus {
            box-shadow: 0px!important;
        }

        &-primary {
            background: $btn-invest;
            font-weight: bold;
            text-transform: uppercase;
            border: none;
            padding-left: 20px;
            padding-right: 20px;

            &:hover {
                background: darken($btn-invest, 5%);
            }

            img {
                width: 25px;
                margin-left: 10px;
                position: relative;
                top: -2px;

                @include ds {
                    width: 13px;
                    top:-1px;
                }
            }

            // MEDIA max: 1199px
            @include brkp-01(1199px) {
                font-size: calcRem(12);
            }
        }

        &-link {
            color: #666;
            &:hover {
                color: #999;
                text-decoration: underline !important;
            }

            &.mob {
                display: none;
            }

            @include brkp-01(767px) {
                &.desk {
                    display: none;
                }

                &.mob {
                    display: inline-block;

                    i {
                        display: inline-block !important;
                    }
                }
            }

            // MEDIA max: 1199px
            @include brkp-01(1199px) {
                font-size: calcRem(12);
            }
        }
    }

   .dashboard {
     .MyLoans {
       &{
         width: 100%;
       }

       .MyLoansHeader {
         &{
            margin-bottom: calcRem(32);

            @include brkp-01(767px) {
                margin-bottom: calcRem(8);
            }

            .text-right {
                @include brkp-01(1199px) {
                    text-align: left !important;
                }
            }

            @include ds {
                margin-bottom: calcRem(0);
            }
         }

         h3 {
             font-size: calcRem(30);
             font-weight: 700;
             color: #434371;

             @include brkp-01(1199px) {
                margin-bottom: 1rem;
             }

             @include xs {
                 font-size: calcRem(20);
             }
         }

        .RequestLoan {
            a {
                display:flex;
                
                & {
                    color: #999999;
                    @include font-size(20px);

                    @include xs {
                        @include font-size(14px);
                    }
                    @include ds {
                        @include font-size(16px);
                    }
                }

                i {
                    background-image: url('/static/assets/images/ico-btn-plus.svg');
                    width: calcRem(33);
                    height: calcRem(33);
                    display: inline-block;
                    vertical-align: middle;
                    margin-right: calcRem(8);
                    margin-bottom: calcRem(8);

                    @include xs {
                        width: calcRem(20);
                        height: calcRem(20);
                    }

                    @include ds {
                        width: calcRem(25);
                        height: calcRem(25);
                    }
                }


            }
        }
    }

       .MyLoansContent {
           .container-fluid {
               .col-12 {
                   padding: 0;
               }
           }
       }

        .table {
            &{
                border: none !important;
                margin-top: 0;

                @include brkp-01(1199px) {
                    tr {
                        th:nth-child(2),
                        td:nth-child(2) {
                            display: none;
                        }
                    }
                }

                @include brkp-01(1005px) {
                    tr {
                        th:nth-child(3),
                        td:nth-child(3),
                        th:nth-child(4),
                        td:nth-child(4),
                        th:nth-child(6),
                        td:nth-child(6){
                            display: none;
                        }

                        th:last-child {
                            width: 40px;
                        }

                        td:last-child {
                            a {
                                &.desk{
                                    display: none;
                                }

                                &.mob {
                                    display: inline-block;
                                    font-size: 1rem;
                                }

                                i {
                                    font-size: 1rem;
                                    display: inline-block;
                                }
                            }
                        }
                    }
                }

                @include brkp-01(767px) {
                    tr {
                        th:nth-child(5),
                        td:nth-child(5){
                            display: none;
                        }

                        th:nth-child(7) {
                            width: 70px;
                        }

                        th:nth-child(8) {
                            width: 100px;
                        }

                        th:nth-child(9) {
                            width: 80px;
                        }
                    }
                }


                @include brkp-01(820px) {
                    tr {
                        th:nth-child(3) {
                            width: 120px;
                        }
                    }
                }
            }

            tr {

                

                & {
                    border-bottom: 1px solid #DDDDDD;

                    &:last-child {
                        border-bottom:none;
                    }
                }

                th, td {
                    text-align: center;
                }

                th {
                    @include font-size(15px);
                    border-top: none;
                    padding: calcRem(10) 0;

                    @include ds {
                        @include font-size(13px);
                    }
                }

                td {
                    @include font-size(15px);
                    color: #999999;
                    border-top: 1px solid #DDDDDD;
                    padding: calcRem(10) 0;

                    @include ds {
                        @include font-size(13px);
                    }
                    
                    &.rating {

                        & {
                            font-weight: 700;
                        }

                        span {
                            &{
                                display: inline-block;
                                vertical-align: middle;
                            }

                            &:first-child {
                                width: 20px;
                                height: 20px;    

                                @include ds {
                                    width: 16px;
                                    height: 16px;
                                }
                            }

                            &:last-child {
                                background-color: transparent !important;
                            }
                        }
                    }

                    a {
                        i {
                            display: none;
                        }
                    }

                    .btn {
                        &-link {
                            @include ds {
                                @include font-size(10px);
                            }
                        }
                    }
                }

                

                .badge {
                    width: calcRem(25);
                    height: calcRem(25);
                    line-height: calcRem(18);
                    margin-left: calcRem(10);
                    font-size: calcRem(12);
                }

                a {
                    font-size: calcRem(15);
                    color: #7b7b7b;
                    text-decoration: underline !important;
                    font-weight: 600;
                }

                // MEDIA max: 1270px 
                @include brkp-01(1270px) {
                    th,
                    td,
                    a {
                        font-size: calcRem(12);
                    }
                }
            }
        }
       }
     }

    .cards {
      dl {
        padding-bottom: 15px;
        margin-bottom: 15px;
        text-align: center;
        border-radius: 0px;
        border:none;
        border-bottom: 1px solid #ddd;

        dt {
          &.rating {
            color: #888;
            margin-bottom:5px;
          }
          .score {
            display: inline-block;
            margin-left: 5px;
            border-radius: 50px;
            width:34px;
            height:34px;
            line-height: 34px;
            color: #fff;
          }
          a {
            font-size: 16px;
            font-weight: normal;
            color: #888;
            &:hover {
              color:#111;
            }
          }
        }
        dd {
          color: #888;
          p {
            color: #888;
            margin-bottom:0px;
          }
        }
        div {
          a {
            &.btn {
              margin-bottom:5px;
              @include font-size(15px);
              line-height: 35px;
              padding-top:0px;
              padding-bottom:0px;
              height:35px;

              &-link {
                @include font-size(15px);
              }
            }
            display: block;
          }
        }
        &:last-child {
          margin-bottom:0px;
          border: none;
        }
      }
      .ss {
          span {
            padding:6px;
            @include font-size(14px);
          }
      }
      .btn {
          &-link {
              @include font-size(14px);
          }
      }
    }     
</style>
<!-- :::::::: -->


<script>
import Modal from "@/components/Modal";
import * as mutationTypes from "@/store/mutation-types.js";
import ApiClient from "@/utils/api-client";
import Masker from "@/utils/masker";
import ArrayHelper from "@/utils/array-helper";

export default {
  data() {
    return {
      emprestimos: null,
      emprestimosEmBreve: false,
      investimentos: '',
      suitability: '',
      investidor: ''
    };
  },
  methods: {
    AjustaLink(item)
    {
        if(item.TipoEmprestimo == "emprestimo-de-impacto2")
        {
            return "/informacoes-adicionais/emprestimo-coletivo/"+item._id;      
        }

      return "/informacoes-adicionais/"+item.TipoEmprestimo+"/"+item._id;
      
    },
    AjustaData(date) {
      return (new Date(date)).toLocaleDateString('pt-BR')
    },
    AjustaStatus(item)
    {
        if(item.TipoEmprestimo.indexOf("coletivo") > 0 || item.TipoEmprestimo.indexOf("impacto2") > 0 || item.TipoEmprestimo.indexOf("social") > 0)
        {
            if(item.Status == "finished" && (item.StatusAnalise == undefined || item.StatusAnalise== "")){
                return "Processando";
            }
            
            if(item.StatusAnalise != null && item.StatusAnalise != undefined && item.StatusAnalise != ""){
                return item.StatusAnalise.substring(0,1) + item.StatusAnalise.toLowerCase().substring(1).replace("_","") ;
            }

              if(item.Status =="NEGADO" ){
                return item.Status.substring(0,1) + item.Status.toLowerCase().substring(1).replace("_","") ;
            }
            
            return "Incompleto";
        }
        else
        {
            if(item.TipoEmprestimo.indexOf("pessoal") > 0)
            {  
                if(item.Status == "finished" && (item.StatusAnalise == undefined || item.StatusAnalise== "")) {
                    return "Processando";
                }

               if(item.StatusAnalise == "NOVERDE") {
                    return "Processando";
                }

                if(item.StatusAnalise != undefined && item.StatusAnalise != "") {
                    return item.StatusAnalise.substring(0,1) + item.StatusAnalise.toLowerCase().substring(1).replace("_","") ;
                }

                return "Incompleto";
            }
            else if(item.TipoEmprestimo.indexOf("impacto") > 0 || item.TipoEmprestimo.indexOf("social") > 0) {
                if(item.Status == "finished" && (item.StatusAnalise == undefined || item.StatusAnalise == "")) {
                    return "Processando";
                }

                if(item.StatusAnalise != undefined && item.StatusAnalise != "") {
                    return item.StatusAnalise.substring(0,1) + item.StatusAnalise.toLowerCase().substring(1).replace("_","") ;
                }

                 return "Processando";
            }
            else {
                return "Processando";
            }
        }
    },
    formatted(doc)
    {
        doc = doc.replace(/\D/g, '')
        
        if(doc.length > 12)
        return Masker.maskCnpj(doc)

        return Masker.maskCpf(doc)
    },
    Nome(item)
    {
        
        var nome  = item.Nome != null ? item.Nome.trim() : "";
        if(nome.indexOf(" ") != -1)
        {
            nome = nome.split(" ")[0]
            return nome.substring(0,1).toUpperCase() +  nome.substring(1);
        }

        return nome.substring(0,1).toUpperCase() +  nome.substring(1);
    },
    formatarTipoEmprestimo(tipoEmprestimo) {

        if(tipoEmprestimo.toLowerCase() == "emprestimo-de-impacto2"){
            return "Impacto";
        }

        tipoEmprestimo = tipoEmprestimo.toLowerCase().replace("-de", "");
        var splitedTipoEmprestimo = tipoEmprestimo.split('-');

        if(tipoEmprestimo.indexOf("emprestimo") > -1)
        {
            if(splitedTipoEmprestimo.length > 1) {
                return splitedTipoEmprestimo[1][0].toUpperCase() + splitedTipoEmprestimo[1].substr(1);
            }

            return tipoEmprestimo[0].toUpperCase() + tipoEmprestimo.substr(1);      
        }

        if(splitedTipoEmprestimo.length > 2) {
            return splitedTipoEmprestimo[2][0].toUpperCase() + splitedTipoEmprestimo[2].substr(1) + "-" + splitedTipoEmprestimo[0][0].toUpperCase() + splitedTipoEmprestimo[0].substr(1,2);
        }
    },
    formatarScore(score) {

      if(score == null)
        return "-";

      if(score.length > 1 && !isNaN(score[1])) {
        return score[0];
      }

      return score == ""?"-":score;
    },
    money(n) {
      var c = 2,
        d = ",",
        t = ".",
        s = n < 0 ? "-" : "",
        i = String(parseInt((n = Math.abs(Number(n) || 0).toFixed(c)))),
        j = (j = i.length) > 3 ? j % 3 : 0;
      return (
        s +
        (j ? i.substr(0, j) + t : "") +
        i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) +
        (c
          ? d +
            Math.abs(n - i)
              .toFixed(c)
              .slice(2)
          : "")
      );
    },
    lowerCase(texto) {
      if (texto == null || texto == undefined || texto == "") return "";

      if (texto == "AA" || texto == "HR") return texto.toLowerCase();

      return texto[0].toLowerCase();
    },
    ajustIdOportunidade(id, qtd) {
      var s = String(id);
  
     if(id == undefined || id == 0)
     return "";

      while (s.length < (qtd || 2)) {
        s = "0" + s;
      }
      return "#"+s;
    },
    inteiro(n) {
      return parseInt((n = Math.abs(Number(n) || 0).toFixed(2)));
    },
    Redirecionar(item){

          /* if(item.TipoEmprestimo == 'emprestimo-coletivo' && AjustaStatus(item) =='Em análise'){
              window.location.href = "#"+  documentos('EMPCOL', item._id)
            }

            if(item.TipoEmprestimo == 'emprestimo-pessoal' && AjustaStatus(item) =='Em análise'){
           
            window.location.href = "#"+  documentos('EMPPES', item._id)
            }

            if(item.TipoEmprestimo == 'emprestimo-coletivo' && (item.StatusAnalise =='APROVADO' || item.StatusAnalise =='PUBLICADO')){
           
            window.location.href = "#"+   Detalhes('EMPCOL', item._id)
            }

            if(item.TipoEmprestimo == 'emprestimo-de-impacto' && (item.StatusAnalise =='APROVADO' || item.StatusAnalise =='PUBLICADO')){
               
                window.location.href = "#"+   Detalhes('EMPIMP', item._id)
            }

            if(item.TipoEmprestimo == 'emprestimo-ccb' && (item.StatusAnalise =='APROVADO' || item.StatusAnalise =='PUBLICADO')){
                
                window.location.href = "#"+  Detalhes('EMPCCB', item._id)
            }*/


    },

    documentos(type, id) {
        return "/emprestimos/pre-aprovado?type=" + type + "&id=" + id;
    },
    DocumentosFaltantes(type, id) {
        return "/emprestimos/documentos?type=" + type + "&id=" + id;
    },
    Detalhes(type, id) {
        return "/emprestimos/detalhes-do-emprestimo?type=" + type + "&id=" + id;
    },
    AssinaturaCCB(id) {
        return "/emprestimos/formalizar-ccb/" + id;
    },

    //tagueamento GA
    taggingGA() {
        this.$ga.page({
            page: '/emprestimos/meus-emprestimos',
            title: 'Meus Emprestimos',
        })
    },
  },
  computed: {
    User: function() {
      return this.$store.state.currentUser;
    }
  },
  async created() {

    if (this.User.tipo.length > 1) {
        this.TipoUser = 'Investidor e Tomador'
    } else if (this.User.tipo[0] === 'INV') {
        this.TipoUser = 'Investidor'
    } else {
        this.TipoUser = 'Tomador'
    }

    this.User.hassuitability === true ? this.suitability = 'Verdadeiro' : this.suitability = 'Falso'
    this.User.hasinvestor === true ? this.investidor = 'Verdadeiro' : this.investidor = 'Falso'
    this.User.hasinvestments === true ? this.investimentos = 'Verdadeiro' : this.investimentos = 'Falso'

    mixpanel.people.set({
        'USER_ID': this.User._id,
        'email': this.User.email,
        'name': this.User.name,
        'Tipo': this.TipoUser,
        'TipoInvestidor': this.User.suitability.Tipo,
        'PreencheuSuitability': this.suitability,
        'Investidor': this.investidor,
        'TemInvestimentos': this.investimentos,
    });
    
    //tagueamento GA
    await this.taggingGA();
  },
  components: { Modal },
  beforeCreate() {
    this.$store.commit(mutationTypes.START_LOADING);

    ApiClient.getMeusEmprestimos()
        .then(emprestimos => {
            this.emprestimos = emprestimos;
            let hasAnalisys  = false;
            let idAnalisys;
            if (this.emprestimos == null || this.emprestimos.length == 0) {
            
            this.emprestimosEmBreve = true;
            }
            window.emprestimo = this.emprestimos;

            this.$store.commit(mutationTypes.STOP_LOADING)
        })
        .catch(() => this.$store.commit(mutationTypes.STOP_LOADING));
  },
};
</script>


// WEBPACK FOOTER //
// src/views/MyLoans.vue